import { Component, inject } from '@angular/core';
import { ChemicalTypeService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ChemicalTypeCreateDto,
  ChemicalTypeDto,
  ChemicalTypeExcelDownloadDto,
  ChemicalTypeUpdateDto,
} from '../proxy/general/dtos/chemical-type';
import { CHEMICALTYPE_CONFIG, CHEMICALTYPE_FIELDS } from './chemical-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-chemical-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ChemicalTypeService, ConfirmationService],
  templateUrl: './chemical-type.html',
  styleUrl: './chemical-type.scss',
})
export class ChemicalType extends BaseCrudComponent<
  ChemicalTypeDto,
  ChemicalTypeCreateDto,
  ChemicalTypeUpdateDto,
  ChemicalTypeExcelDownloadDto
> {
  service = inject(ChemicalTypeService);
  config = CHEMICALTYPE_CONFIG;
  fields = CHEMICALTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ChemicalTypeDto): ChemicalTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ChemicalType';
  }
}
